import * as React from 'react';
import {
  DashboardMenuItem,
  usePermissions
} from 'react-admin';

import Divider from '@mui/material/Divider';
import { MultiLevelMenu, MenuItemNode } from "@react-admin/ra-navigation";
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import QuizIcon from '@mui/icons-material/Quiz';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CategoryIcon from '@mui/icons-material/Category';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import GroupsIcon from '@mui/icons-material/Groups';
import { iconStyle } from '../Styles/iconsStyles';
import { cssMultiLevelMenu } from '../Styles/menuStyles';

export const MyMenu = (props) => {

  const { permissions } = usePermissions();

  return (
    <MultiLevelMenu sx={cssMultiLevelMenu}>


      {permissions === 'admin' &&
        <>
          {/* Voce Macro Aree e Domande */}
          {/* <DashboardMenuItem sx={iconStyle} /> */}
          <MenuItemNode name="dashboard" to="/" label="Dashboard" icon={<DashboardIcon style={iconStyle} />} />

          <br></br>

          <MenuItemNode name="macroaree" to="/tbl-macroaree" label="Macro Aree" icon={<CategoryIcon style={iconStyle} />} />


          <MenuItemNode name="domande" to="/tbl-domande" label="Domande" icon={<QuizIcon style={iconStyle} />} />

          <Divider></Divider>

          {/* Voce menu Statistiche */}
          {/*           <MenuItemNode name="risultati" to="/statistiche" label="Risultati" icon={<LeaderboardIcon style={iconStyle} />}>
            <MenuItemNode name="risultati" to="/statistiche" label="Risultati" icon={<LeaderboardIcon style={iconStyle} />} />
          </MenuItemNode> */}

          <MenuItemNode name="quiz" to="/tbl-quiz" label="Sondaggi" icon={<PlaylistAddCheckIcon style={iconStyle} />} />

          <Divider></Divider>

          <MenuItemNode name="users" to="/users" label="Gestione Accessi" icon={<AdminPanelSettingsIcon style={iconStyle} />} />

          <Divider></Divider>

          <MenuItemNode name="users" to="/tbl-collaboratori" label="Collaboratori" icon={<GroupsIcon style={iconStyle} />} />

          <Divider></Divider>

          <MenuItemNode name="logtrack" to="/logtrack" label="Logs" icon={<ManageHistoryIcon style={iconStyle} />} />

          <Divider></Divider>
        </>}

      {permissions === 'collaboratore' &&
        <>
          {/* Voce Macro Aree e Domande */}
          {/* <DashboardMenuItem sx={iconStyle} /> */}
          <MenuItemNode name="dashboard" to="/" label="Dashboard" icon={<DashboardIcon style={iconStyle} />} />

          <MenuItemNode name="quiz" to="/tbl-quiz" label="Sondaggi" icon={<PlaylistAddCheckIcon style={iconStyle} />} />

        </>}
    </MultiLevelMenu>
  );
};


/* 
ANAGRAFICHE
BOOKING
LISTINI
SOFTWARE COLLEGATI
STATISTICHE

*/